import ConnectServer from 'utils/connect_server'
import * as types from 'redux/types'
import { message } from 'antd';


export const onChangeBasket = (prop, value): any => (dispatch) => {
  dispatch({ type: types.CHANGE_BASKET, payload: { prop, value } });
}

export const getProduct = (): any => (dispatch) => {
  onChangeBasket('getProductLoading',true)(dispatch)
  
  return ConnectServer(`product/index`, "POST", 'application/json', null).then((res: any) => {
    onChangeBasket('productList',res.items)(dispatch)  
    return res
  }).finally(() => { 
    onChangeBasket('getProductLoading',false)(dispatch)  
  })
}
export const getUserSubscription = (ctx): any => (dispatch) => {
  onChangeBasket('getUserSubscriptionLoading',true)(dispatch)
  return ConnectServer(`basic-authentication/view-customer?id=${ctx.user.id}`, "POST", 'application/json', null).then((res: any) => {
    // onChangeBasket('productList',res.items)(dispatch)  
    ctx.updateUser(res)
    return res
  }).finally(() => { 
    onChangeBasket('getUserSubscriptionLoading',false)(dispatch)  
  })
}
export const createBasketAction = (data): any => (dispatch) => {
  onChangeBasket('createBasketLoading',data.products[0].product_id)(dispatch)
  return ConnectServer(`order/create`, "POST", 'application/json',JSON.stringify(data)).then((res: any) => {
    onChangeBasket('productCreateInfo',res)(dispatch)  
    return res
  }).finally(() => { 
    onChangeBasket('createBasketLoading',null)(dispatch)  
  })
}


